import axios from '@/utils/request'
import { AxiosPromise } from 'axios'
import { BaseResponse, ResponseStatus } from '.'

export { BaseResponse, ResponseStatus }

export enum DraftAction {
  Ban = 'Ban',
  Pick = 'Pick'
}

export enum DraftRepeatBehavior {
  NoRepeat = 'NoRepeat',
  RepeatTeam = 'RepeatTeam',
  RepeatAll = 'RepeatAll'
}

export interface DraftEntity {
  draftId: string
  name: string
  steps: DraftStepEntity[]
}

export interface DraftStepEntity {
  step: number
  action: DraftAction
  teamNumber: number
  isSkippable: boolean
  isTimeoutRandom: boolean
  repeatBehavior: DraftRepeatBehavior
  duration: number
  isSystemRandom: boolean
}

export interface DraftOptionEntity {
  draftOptionId: string
  name: string
  image: string
  icon: string
  tags: string[]
}

export interface DraftResultEntity {
  step: number
  action: DraftAction
  teamNumber: number
  choice: DraftOptionEntity | null
  isSkippable: boolean
  isTimeoutRandom: boolean
  repeatBehavior: DraftRepeatBehavior
  duration: number
  submitTime: number | null
  isTimeout: boolean
  isSystemRandom: boolean
  isBlind: boolean
}

export enum DraftSessionState {
  Initial = 'Initial',
  InProgress = 'InProgress',
  Complete = 'Complete',
  Cancel = 'Cancel'
}

export interface DraftSessionEntity {
  draftSessionId: string
  draftId: string
  currentStep: number
  nextTimeoutTime: number
  state: DraftSessionState
  results: DraftResultEntity[]
  teams: DraftTeamEntity[]
}

export interface DraftTeamEntity {
  number: number
  name: string
}

export interface DraftSessionResponse {
  session: DraftSessionEntity
  draft: DraftEntity
}

export class DraftAPI {
  public static getDraftSession(
    draftSessionId: string
  ): AxiosPromise<BaseResponse<DraftSessionResponse>> {
    return axios.get(`/draft/v1/draft/sessions/${draftSessionId}`)
  }

  public static getDraftOptions(
    draftSessionId: string
  ): AxiosPromise<BaseResponse<DraftOptionEntity[]>> {
    return axios.get(`/draft/v1/draft/sessions/${draftSessionId}/options`)
  }

  public static submitChoice(
    draftSessionId: string,
    choice: string,
    teamNumber: number
  ): AxiosPromise<BaseResponse> {
    return axios.post(`/draft/v1/draft/sessions/${draftSessionId}`, {
      choice,
      teamNumber
    })
  }

  public static updateChoice(
    draftSessionId: string,
    choice: string,
    teamNumber: number
  ): AxiosPromise<BaseResponse> {
    return axios.post(`/draft/v1/draft/sessions/${draftSessionId}/update`, {
      choice,
      teamNumber
    })
  }
}
